// import React from 'react';

import DateRangePicker from './DateRangePicker';
// import DatePicker from './DatePicker';

// import classes from './index.module.css';

export default () => (
  <>
    <DateRangePicker />
    {/* <DatePicker /> */}
  </>
);
